export const REVIEWS_ENTITIES = 'reviews_entities';
export const ADD_REVIEW = 'add_review';
export const SET_SINGLE_REVIEW = 'set_single_review';
export const SET_REVIEWS = 'set_reviews';
